import { render, staticRenderFns } from "./FirmantesForm.vue?vue&type=template&id=20b82a0c&"
import script from "./FirmantesForm.vue?vue&type=script&lang=js&"
export * from "./FirmantesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports